import { Box, FormLabel, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { adminSelectStyles } from "../../../components/Models/admin-modal-theme";
import {
  FIXED_GEMINI_FLASH,
  fallbackCatalog,
  findGroupedOption,
  loadGraderModelCatalog,
  rememberGradingModel,
  rememberedGradingModelId,
  resolveGradingModel,
  toGradingModelGroups,
} from "../../../modules/admin-modules/mark-schemes/grader-models";

const selectStyles = {
  ...adminSelectStyles(),
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  groupHeading: (base) => ({
    ...base,
    color: "var(--text-muted)",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  }),
};

export function useGradingModelSelection(active) {
  const [groups, setGroups] = useState(() => toGradingModelGroups(fallbackCatalog()));
  const [gradingModel, setGradingModel] = useState(
    () => rememberedGradingModelId() || FIXED_GEMINI_FLASH
  );
  const [isLoadingModels, setIsLoadingModels] = useState(false);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    setIsLoadingModels(true);
    loadGraderModelCatalog()
      .then((catalog) => {
        if (cancelled) return;
        const nextGroups = toGradingModelGroups(catalog);
        const nextModel = resolveGradingModel(
          catalog,
          nextGroups,
          rememberedGradingModelId()
        );
        setGroups(nextGroups);
        setGradingModel(nextModel);
        rememberGradingModel(nextModel);
      })
      .finally(() => {
        if (!cancelled) setIsLoadingModels(false);
      });
    return () => {
      cancelled = true;
    };
  }, [active]);

  const onGradingModelChange = (modelId) => {
    rememberGradingModel(modelId);
    setGradingModel(modelId);
  };

  return { groups, gradingModel, onGradingModelChange, isLoadingModels };
}

const GradingModelField = ({ groups, value, onChange, isDisabled, isLoading }) => (
  <Box>
    <FormLabel fontSize="xs" fontWeight="700" mb={1}>
      Grading model
    </FormLabel>
    <Select
      styles={selectStyles}
      options={groups}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      value={findGroupedOption(groups, value)}
      onChange={(option) => onChange(option?.value ?? FIXED_GEMINI_FLASH)}
      placeholder="Select grading model"
      isLoading={isLoading}
      isDisabled={isDisabled || isLoading}
      isClearable={false}
    />
    <Text fontSize="xs" color="var(--text-muted)" mt={2} fontWeight="600">
      OCR uses Gemini 2.5 Flash.
    </Text>
  </Box>
);

export default GradingModelField;
